'use client'
import { useState } from "react";
import { IoMdShare } from "react-icons/io";
import tailwindConfig from '@tailwind.config'


const ShareButton = ({ title, text, url, cover, dictionary, lang }) => {
    const [isSharing, setIsSharing] = useState(false);

    const handleClick = async () => {
        setIsSharing(true);

        try {
            const shareData = {
                title: title,
                text: text,
                url: `/${url}`,
                image: `${cover}`
            };

            // console.log(shareData)

            const shareDialog = await window.navigator.share(shareData);
            shareDialog.addEventListener("shared", () => {
                setIsSharing(false);
            });
            shareDialog.addEventListener("dismissed", () => {
                setIsSharing(false);
            });
        } catch (error) {
            setIsSharing(false);
        }
    };

    return (
        <button onClick={handleClick} disabled={isSharing}>
            <div className="flex flex-col items-center">
                <IoMdShare
                    color={tailwindConfig.theme.extend.colors.secondary}
                    size={24}
                />
                <span className="text-maincolor">{dictionary.property.share}</span>
            </div>

        </button>
    );
};

export default ShareButton;